export function isCanonicalBase64(value: string): boolean {
  if (!/^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/.test(value)) return false;
  try {
    const binary = globalThis.atob(value);
    return globalThis.btoa(binary) === value;
  } catch {
    return false;
  }
}

export function assertNoDuplicateJsonKeys(text: string): void {
  const objectKeys: Array<Set<string> | null> = [];
  const token = /"(?:\\.|[^"\\])*"|[{}:,]|\[|\]|-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?|true|false|null/g;
  let match: RegExpExecArray | null;
  while ((match = token.exec(text)) !== null) {
    const value = match[0];
    if (value === '{') objectKeys.push(new Set());
    else if (value === '[') objectKeys.push(null);
    else if (value === '}' || value === ']') objectKeys.pop();
    else if (value.startsWith('"')) {
      const remaining = text.slice(token.lastIndex);
      if (/^\s*:/.test(remaining)) {
        const current = objectKeys[objectKeys.length - 1];
        const key = JSON.parse(value) as string;
        if (current === null || current === undefined) throw new Error('maintenance_json_invalid_key');
        if (current.has(key)) throw new Error('maintenance_json_duplicate_key');
        current.add(key);
      }
    }
  }
}
